export const getStyles = (
  theme: any,
  hasSecondaryButton: boolean,
  isDropdownOpened: boolean
) => ({
  styles: {
    actions: {
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      color: theme.palette.grey[0],
      lineHeight: "48px",
      marginRight: "36px",
      fontSize: "30px !important",
    },
    description: {
      color: theme.palette.grey[600],
      lineHeight: "24px",
      fontSize: "15px",
    },
    buttons: {
      display: "flex",
      justifyContent: hasSecondaryButton ? "space-between" : "flex-end",
      minWidth: 260,
    },
    button: {
      onDelete: {
        color: theme.palette.grey[0],
        cursor: "pointer",
        fontSize: "12px",
        "& .MuiButton-endIcon": {
          ml: "17px",
        },
        padding: hasSecondaryButton ? "0px 40px" : "0 20px",

        "&:hover": {
          backgroundColor: "transparent",
          opacity: 0.8,
        },
      },
      onPublish: {
        alignItems: "center",
        background: theme.palette.grey[0],
        borderRadius: "100px",
        color: theme.palette.grey[500],
        display: "flex",
        fontSize: "12px",
        height: "48px",
        marginLeft: "auto",
        minWidth: "133px",
        padding: "24px 30px",
        "& path": { stroke: theme.palette.grey[900] },

        "&:hover": {
          background: theme.palette.grey[0],
          opacity: 1,
        },
      },
    },
    dropdown: {
      position: "absolute" as "absolute",
      left: "0",
      top: "30px",
      display: isDropdownOpened ? "block" : "none",
      zIndex: 12,
      backgroundColor: theme.palette.grey[700],
      color: theme.palette.grey[0],
      width: "201px",
      height: "184px",
      borderRadius: "8px",
      padding: "20px",
      filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    },
    dropdown_title: {
      fontSize: "10px",
      lineHeight: "16px",
    },
    stream: {
      cursor: "pointer",
      fontSize: "16px",
      lineHeight: "24px",
    },
    streams: {
      display: "flex",
      alignItems: "center",
      position: "relative" as "relative",
      cursor: "pointer",
    },
    stream_name: {
      color: theme.palette.grey[0],
      margin: "0 10px 0 0",
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
});
